import GeoJSON from 'ol/format/GeoJSON';
import {object, string} from 'prop-types';
import {connect} from 'react-redux';
import {getDistanceUnits} from '@app/selectors/measurements';
import formatDistance, {localizationMap} from '@app/util/format-distance.js';

const LengthIndicator = ({geometry, units}) => {
  if (!geometry) {
    return '';
  } else {
    const olGeom = new GeoJSON().readGeometry(geometry);
    const distance = formatDistance(olGeom, units, '0,0[.]000', {
      projection: 'EPSG:4326',
    });
    return localizationMap[units]
      ? `${distance} ${localizationMap[units]}`
      : null;
  }
};

LengthIndicator.propTypes = {
  geometry: object,
  units: string.isRequired,
};

const mapStateToProps = state => ({
  units: getDistanceUnits(state),
});

export default connect(mapStateToProps)(LengthIndicator);
